var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 37.5",
    xmlSpace: "preserve",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-570 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 579,
    cy: 92,
    r: 2,
    fill: "grey"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "grey",
    points: "590.908,86 590.315,88 595,88 595,103 585.871,103 585.278,105 597,105 597,86   "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "grey",
    d: "M586.167,102H588h6v-2.857c-1.997-2.776-2.954-6.657-4.883-7.098L586.167,102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "grey",
    d: "M588.041,81.716L586.771,86H573v19h8.143l-1.102,3.716l1.918,0.568l8-27L588.041,81.716z M583.31,97.682    c-0.668-0.861-1.34-1.396-2.06-1.396c-1.955,0-2.674,4.157-5.25,4.999V102h2.25h3.781l-0.296,1H575V88h11.18L583.31,97.682z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/broken-image.caad4d6fc9e42cbbe33ba2cc017184c2.svg";
export { ForwardRef as ReactComponent };